import { useState } from 'react'
import { APP_ENV } from '../../lib/env'
import { APP_VERSION, CHANGELOG } from '../../lib/changelog'
import { releaseDate } from '../../lib/releaseDate'

// The foot of Settings: the version — a tap shows what's new in it — then
// Privacy, Terms and Sign out. Only this release's notes; nothing more.
export function AboutFooter({ onSignOut }: { onSignOut: () => void }) {
  const [open, setOpen] = useState(false)
  const release = CHANGELOG.find(r => r.version === APP_VERSION) ?? CHANGELOG[0]
  // The environment only outside production: a family member never sees "(production)".
  const version = APP_ENV === 'production' ? APP_VERSION : `${APP_VERSION} (${APP_ENV})`

  return (
    <footer className="ml-settings__footer">
      {release ? (
        <button type="button" className="ml-settings__version" aria-expanded={open} onClick={() => setOpen(v => !v)}>
          Matlist {version}
        </button>
      ) : (
        <p className="ml-settings__version">Matlist {version}</p>
      )}
      {open && release && (
        <section className="ml-changelog" aria-label={`What's new in ${release.version}`}>
          <p className="ml-changelog__head">
            <span className="ml-changelog__version">What's new</span>
            <span className="ml-changelog__date">{releaseDate(release.date)}</span>
          </p>
          <ul className="ml-changelog__notes">
            {release.notes.map(n => <li key={n}>{n}</li>)}
          </ul>
        </section>
      )}
      <div className="ml-settings__footer-links">
        <span className="ml-settings__legal">
          <a className="ml-text-btn ml-text-btn--quiet" href="/privacy.html">Privacy</a>
          <a className="ml-text-btn ml-text-btn--quiet" href="/terms.html">Terms</a>
        </span>
        <button type="button" className="ml-text-btn ml-text-btn--destructive" onClick={onSignOut}>Sign out</button>
      </div>
    </footer>
  )
}
